(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const year = document.getElementById("year");
  if (year) year.textContent = String(new Date().getFullYear());

  const AGE_KEY = "foc-age-verified";
  const loader = document.getElementById("loader");
  const loaderCount = document.getElementById("loader-count");
  const loaderBar = document.getElementById("loader-bar");
  const ageGate = document.getElementById("age-gate");
  const intro = document.getElementById("intro");
  const video = document.querySelector(".intro-video");
  const topbar = document.getElementById("topbar");
  const menuBtn = document.getElementById("menu-btn");
  const overlay = document.getElementById("overlay-nav");
  const cursor = document.querySelector(".cursor");

  /* ——— Custom cursor ——— */
  if (cursor && !reduce && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    let x = 0;
    let y = 0;
    let cx = 0;
    let cy = 0;

    window.addEventListener(
      "pointermove",
      (e) => {
        x = e.clientX;
        y = e.clientY;
      },
      { passive: true }
    );

    const tickCursor = () => {
      cx += (x - cx) * 0.22;
      cy += (y - cy) * 0.22;
      cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      requestAnimationFrame(tickCursor);
    };
    tickCursor();

    document.querySelectorAll("a, button, [data-magnetic]").forEach((el) => {
      el.addEventListener("pointerenter", () => cursor.classList.add("is-hot"));
      el.addEventListener("pointerleave", () => cursor.classList.remove("is-hot"));
    });
  }

  /* ——— Can tilt in hero (desktop only) ——— */
  const tilt = document.querySelector("[data-tilt]");
  const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (tilt && !reduce && finePointer) {
    const zone = intro || document;
    zone.addEventListener(
      "pointermove",
      (e) => {
        const nx = (e.clientX / window.innerWidth - 0.5) * 2;
        const ny = (e.clientY / window.innerHeight - 0.5) * 2;
        tilt.style.transform = `rotateY(${nx * 7}deg) rotateX(${-ny * 5}deg) translateY(${ny * -6}px)`;
      },
      { passive: true }
    );
  }

  /* ——— Magnetic buttons (desktop only) ——— */
  if (!reduce && finePointer) {
    document.querySelectorAll("[data-magnetic]").forEach((el) => {
      el.addEventListener("pointermove", (e) => {
        const r = el.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = `translate(${dx * 0.18}px, ${dy * 0.22}px)`;
      });
      el.addEventListener("pointerleave", () => {
        el.style.transform = "";
      });
    });
  }

  /* ——— Overlay menu ——— */
  function setNav(open) {
    if (!menuBtn || !overlay) return;
    menuBtn.setAttribute("aria-expanded", String(open));
    overlay.hidden = !open;
    overlay.classList.toggle("is-open", open);
    document.body.classList.toggle("is-nav-open", open);
  }

  menuBtn?.addEventListener("click", () => {
    const open = menuBtn.getAttribute("aria-expanded") !== "true";
    setNav(open);
  });

  overlay?.querySelectorAll("[data-nav]").forEach((link) => {
    link.addEventListener("click", () => setNav(false));
  });

  /* ——— Topbar solid after hero ——— */
  if (topbar && intro) {
    const syncBar = () => {
      topbar.classList.toggle("is-solid", window.scrollY > intro.offsetHeight * 0.65);
    };
    syncBar();
    window.addEventListener("scroll", syncBar, { passive: true });
  }

  /* ——— Scroll reveals ——— */
  const reveals = document.querySelectorAll("[data-reveal]");
  if (reduce) {
    reveals.forEach((el) => el.classList.add("is-in"));
  } else if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-in"));
  }

  /* ——— Merch flip ——— */
  document.querySelectorAll("[data-flip]").forEach((block) => {
    const btn = block.querySelector(".product-flip-btn");
    if (!btn) return;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const on = block.classList.toggle("is-flipped");
      const title =
        block.closest("[data-product]")?.dataset.name ||
        block.closest(".product")?.querySelector("h3")?.textContent?.trim() ||
        "Item";
      btn.setAttribute("aria-label", on ? `${title} — view front` : `${title} — view back`);
    });
  });

  /* ——— Shopify Ajax cart drawer ——— */
  const routes = window.theme?.routes || {};
  const moneyFormat = window.theme?.moneyFormat || "${{amount}}";
  const cartBtn = document.getElementById("cart-btn");
  const cartDrawer = document.getElementById("cart-drawer");
  const cartClose = document.getElementById("cart-close");
  const cartItemsEl = document.getElementById("cart-items");
  const cartEmpty = document.getElementById("cart-empty");
  const cartCount = document.getElementById("cart-count");
  const cartSubtotal = document.getElementById("cart-subtotal");
  const cartCheckout = document.getElementById("cart-checkout");

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    if (typeof moneyFormat === "string" && moneyFormat.includes("{{amount}}")) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    return `$${amount}`;
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    document.body.classList.add("is-cart-open");
    cartClose?.focus();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    document.body.classList.remove("is-cart-open");
  }

  async function fetchCart() {
    const res = await fetch((routes.cart || "/cart") + ".js", { credentials: "same-origin" });
    return res.json();
  }

  function renderShopifyCart(cart) {
    if (!cartItemsEl) return;
    cartItemsEl.innerHTML = "";
    const qty = cart.item_count || 0;

    if (cartCount) {
      cartCount.hidden = qty === 0;
      cartCount.textContent = String(qty);
    }
    if (cartEmpty) cartEmpty.hidden = qty > 0;
    if (cartCheckout) cartCheckout.disabled = qty === 0;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price || 0);

    (cart.items || []).forEach((item) => {
      const li = document.createElement("li");
      const img = item.image ? `<img src="${item.image}" alt="" width="64" height="64" />` : "<span></span>";
      li.innerHTML = `
        ${img}
        <div>
          <strong>${item.product_title}</strong>
          <em>${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title + " · " : ""}Qty ${item.quantity}</em>
          <button type="button" class="cart-remove" data-line="${item.key}">${window.theme?.strings?.remove || "Remove"}</button>
        </div>
        <span class="cart-line-price">${formatMoney(item.final_line_price)}</span>
      `;
      cartItemsEl.appendChild(li);
    });
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderShopifyCart(cart);
      return cart;
    } catch (e) {
      console.error(e);
    }
  }

  cartItemsEl?.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-line]");
    if (!btn) return;
    const key = btn.getAttribute("data-line");
    await fetch(routes.cartChange || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await refreshCart();
  });

  function syncVariantFromOptions(form) {
    const jsonEl = form.querySelector(".product-variants-json");
    const idInput = form.querySelector(".product-variant-id, [name='id']");
    if (!jsonEl || !idInput) return;
    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }
    const selected = [];
    form.querySelectorAll(".sizes input:checked").forEach((input) => {
      const pos = Number(input.dataset.optionPosition || selected.length + 1);
      selected[pos - 1] = input.value;
    });
    const match = variants.find((v) =>
      selected.every((val, i) => !val || v[`option${i + 1}`] === val)
    );
    if (match) {
      idInput.value = match.id;
      const btn = form.querySelector("[type='submit'], .add-btn");
      if (btn) {
        btn.disabled = !match.available;
        const addLabel = btn.getAttribute("data-add-label") || "Add to bag";
        btn.textContent = match.available ? addLabel : "Sold out";
      }

      const priceEl = document.getElementById("PdpPrice");
      const compareEl = document.getElementById("PdpCompare");
      const stockEl = document.getElementById("PdpStock");
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (stockEl) {
        const inLabel = stockEl.getAttribute("data-in") || "In stock";
        const outLabel = stockEl.getAttribute("data-out") || "Sold out";
        stockEl.textContent = match.available ? inLabel : outLabel;
        stockEl.classList.toggle("is-out", !match.available);
      }
    }
  }

  document.querySelectorAll("form.product-form, form[action*='/cart/add']").forEach((form) => {
    form.querySelectorAll(".sizes input").forEach((input) => {
      input.addEventListener("change", () => syncVariantFromOptions(form));
    });
  });

  document.querySelectorAll("[data-ajax-add]").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      const form = btn.closest("form");
      if (!form) return;
      e.preventDefault();
      syncVariantFromOptions(form);
      const id = form.querySelector("[name='id']")?.value;
      if (!id) return;
      const qty = Number(form.querySelector("[name='quantity']")?.value || 1);

      btn.classList.add("is-added");
      const original = btn.textContent;
      btn.textContent = window.theme?.strings?.added || "Added";

      try {
        await fetch(routes.cartAdd || "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(id), quantity: Math.max(1, qty) }),
        });
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit();
      }

      setTimeout(() => {
        btn.classList.remove("is-added");
        btn.textContent = original;
      }, 1200);
    });
  });

  cartBtn?.addEventListener("click", async () => {
    await refreshCart();
    openCart();
  });
  cartClose?.addEventListener("click", closeCart);
  cartDrawer?.addEventListener("click", (e) => {
    if (e.target === cartDrawer) closeCart();
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setNav(false);
      closeCart();
    }
  });

  if (cartDrawer) refreshCart();

  /* ——— Age gate ——— */
  function showAgeGate() {
    if (document.body.dataset.ageGate === "false" || !ageGate) {
      unlockIntro();
      return;
    }

    if (sessionStorage.getItem(AGE_KEY) === "yes") {
      document.body.classList.remove("is-age-locked");
      unlockIntro();
      return;
    }

    document.body.classList.add("is-age-locked");
    ageGate.hidden = false;
    const denied = ageGate.querySelector(".age-denied");
    ageGate.querySelector('[data-age="yes"]')?.focus();

    ageGate.querySelectorAll("[data-age]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.getAttribute("data-age") === "yes") {
          sessionStorage.setItem(AGE_KEY, "yes");
          ageGate.hidden = true;
          document.body.classList.remove("is-age-locked");
          unlockIntro();
        } else {
          if (denied) denied.hidden = false;
          const exit = ageGate.dataset.exitUrl;
          if (exit) window.location.href = exit;
        }
      });
    });
  }

  function unlockIntro() {
    intro?.classList.add("is-ready");
    if (video instanceof HTMLVideoElement) {
      video.play().catch(() => {});
    }
  }

  /* ——— Loader with counting ——— */
  let progress = 0;
  let display = 0;
  let finished = false;
  let rafId = 0;

  function paintLoader() {
    display += (progress - display) * 0.12;
    if (Math.abs(progress - display) < 0.2) display = progress;
    const n = Math.round(display);
    if (loaderCount) loaderCount.textContent = String(n);
    if (loaderBar) loaderBar.style.width = `${display}%`;
    if (!finished || display < 99.5) rafId = requestAnimationFrame(paintLoader);
  }

  function setProgress(v) {
    progress = Math.max(progress, Math.min(100, v));
  }

  function finishLoading() {
    if (finished) return;
    finished = true;
    setProgress(100);

    const wrapUp = () => {
      document.body.classList.remove("is-loading");
      if (!loader) {
        showAgeGate();
        return;
      }
      loader.classList.add("is-done");
      loader.setAttribute("aria-busy", "false");
      let once = false;
      const go = () => {
        if (once) return;
        once = true;
        loader.remove();
        showAgeGate();
      };
      if (reduce) go();
      else {
        loader.addEventListener("transitionend", go);
        setTimeout(go, 900);
      }
    };

    setTimeout(wrapUp, reduce ? 0 : 280);
  }

  function boot() {
    /* Loader only exists on homepage */
    if (!loader) {
      document.body.classList.remove("is-loading");
      showAgeGate();
      return;
    }

    rafId = requestAnimationFrame(paintLoader);
    setProgress(8);

    const jobs = [
      new Promise((resolve) => {
        if (document.readyState === "complete") resolve();
        else window.addEventListener("load", () => resolve(), { once: true });
      }).then(() => setProgress(58)),
    ];

    if (video instanceof HTMLVideoElement) {
      jobs.push(
        new Promise((resolve) => {
          if (video.readyState >= 3) {
            resolve();
            return;
          }
          const done = () => resolve();
          video.addEventListener("canplaythrough", done, { once: true });
          video.addEventListener("error", done, { once: true });
          setTimeout(done, 9000);
        }).then(() => setProgress(92))
      );
    }

    /* Fake ease so the counter always feels alive */
    const pulse = setInterval(() => {
      if (progress < 88) setProgress(progress + 1.5);
    }, 180);

    Promise.all(jobs).then(() => {
      clearInterval(pulse);
      setTimeout(finishLoading, reduce ? 0 : 400);
    });
  }

  boot();

  /* ——— Lookbook masonry: flush outer edges ——— */
  const lifeGrid = document.querySelector(".life-grid");
  if (lifeGrid) {
    const gapPx = () => {
      const raw = getComputedStyle(lifeGrid).getPropertyValue("--life-gap").trim() || "8px";
      if (raw.endsWith("rem")) {
        const root = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        return parseFloat(raw) * root;
      }
      return parseFloat(raw) || 8;
    };

    const colCount = () => (window.innerWidth <= 980 ? 2 : 3);

    const layoutLife = () => {
      const items = Array.from(lifeGrid.querySelectorAll(".life-shot"));
      if (!items.length) return;

      const gap = gapPx();
      const cols = colCount();
      const width = lifeGrid.clientWidth;
      if (width <= 0) return;

      const colW = (width - gap * (cols - 1)) / cols;
      const colH = Array(cols).fill(0);
      const colLast = Array(cols).fill(null);

      lifeGrid.classList.add("is-masonry");

      items.forEach((item) => {
        item.style.width = `${colW}px`;
        item.style.height = "";
        item.style.transform = "none";
        const img = item.querySelector("img");
        if (img) {
          img.style.height = "";
          img.style.objectFit = "";
        }
      });

      items.forEach((item) => {
        const h = item.getBoundingClientRect().height;
        const col = colH.indexOf(Math.min(...colH));
        const x = col * (colW + gap);
        const y = colH[col];
        item.style.transform = `translate(${x}px, ${y}px)`;
        colH[col] = y + h + gap;
        colLast[col] = item;
      });

      const maxH = Math.max(...colH);
      lifeGrid.style.height = `${Math.max(0, maxH - gap)}px`;

      colLast.forEach((item, col) => {
        if (!item) return;
        const naturalBottom = colH[col] - gap;
        const target = maxH - gap;
        const deficit = target - naturalBottom;
        if (deficit <= 1) return;

        const current = item.getBoundingClientRect().height;
        item.style.height = `${current + deficit}px`;
        const img = item.querySelector("img");
        if (img) {
          img.style.height = "100%";
          img.style.objectFit = "cover";
        }
      });
    };

    const whenImagesReady = () => {
      const imgs = Array.from(lifeGrid.querySelectorAll("img"));
      return Promise.all(
        imgs.map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.addEventListener("load", resolve, { once: true });
                img.addEventListener("error", resolve, { once: true });
              })
        )
      );
    };

    let resizeTimer = 0;
    whenImagesReady().then(() => {
      layoutLife();
      window.addEventListener("resize", () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => requestAnimationFrame(layoutLife), 120);
      });
      if ("ResizeObserver" in window) {
        new ResizeObserver(() => requestAnimationFrame(layoutLife)).observe(lifeGrid);
      }
    });
  }
})();
